import Toastr from "../../itrust_common/components/Toastr"
const DEFAULT_STATE = {
  resource_transfer_logs: [],
  stores: [],
  meta: { pagination: {} },
  saving: false
}

let changes = null;
export default function staffTransferReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)
  let resource_transfer_logs = []
  let updatedRecord = {};

  switch (action.type) {
    case 'STAFF_TRANSFER_CREATE_PENDING':
      return { ...state, saving: true };

    case 'STAFF_STORES_STRUCTURE_LOAD_REJECTED':
    case 'TRANSFERRED_STAFFS_LOAD_REJECTED':
    case 'STAFF_TRANSFER_CREATE_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = { saving: false }
      return { ...state, ...changes };

    case 'STAFF_TRANSFER_CREATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      resource_transfer_logs = [...state.resource_transfer_logs]
      let newRecord = response.resource_transfer_log
      changes = {
        resource_transfer_logs: [newRecord, ...resource_transfer_logs],
        stores: [],
        editing: false,
        saving: false
      }
      return { ...state, ...changes };

    case 'STAFF_STORES_STRUCTURE_LOAD_FULFILLED':
    case 'TRANSFERRED_STAFFS_LOAD_FULFILLED':
      changes = { ...response, saving: false }
      return { ...state, ...changes };

    case 'STAFF_TRANSFER_EDIT':
      changes = { editing: { ...action.data, }, };
      return { ...state, ...changes };

    case 'STAFF_TRANSFER_EDIT_CANCEL':
      changes = { editing: false };
      return { ...state, ...changes };

    case 'STAFF_TRANSFER_RESET':
      changes = { stores: [] };
      return { ...state, ...changes };

    default:
      return state;
  }
}